import { render } from "./VisualCanvas.vue?vue&type=template&id=05aa2c91&scoped=true"
import script from "./VisualCanvas.vue?vue&type=script&lang=js"
export * from "./VisualCanvas.vue?vue&type=script&lang=js"

import "./VisualCanvas.vue?vue&type=style&index=0&id=05aa2c91&lang=scss&scoped=true"
import "./VisualCanvas.vue?vue&type=style&index=1&id=05aa2c91&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05aa2c91"]])

export default __exports__